"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTextTransform = useTextTransform;
exports.variantsWithTransforms = void 0;
var _useScaleDensity = require("../scale/useScaleDensity");
const variantsWithTransforms = {
  dense: new Set(['caption']),
  normal: new Set(['caption'])
};
exports.variantsWithTransforms = variantsWithTransforms;
function useTextTransform(name, override) {
  const scaleDensity = (0, _useScaleDensity.useScaleDensity)();
  const transformsForScale = variantsWithTransforms[scaleDensity];
  if (override) return override;
  if (transformsForScale.has(name)) {
    return 'uppercase';
  }
  return undefined;
}